import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { NewPassword } from '@descope/page-editor-components';
import { EditorNewPasswordSettings } from './EditorNewPasswordSettings';

type Props = React.ComponentProps<typeof NewPassword>;

const EditorNewPassword = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<NewPassword ref={refCb} {...props} readOnly data-testid="newpassword" />
	);
};

EditorNewPassword.craft = {
	name: 'New Password',
	props: {
		fullWidth: true,
		size: 'md',
		isConfirm: false,
		label: 'Password',
		placeholder: 'Password',
		name: 'newPassword',
		confirmInputProps: {
			label: 'Confirm password',
			placeholder: 'Confirm password'
		},
		autoComplete: null as any // we cannot use undefined because we getting the uncontrolled to controlled warning, and empty string is adding the attribute to the dom
	},
	custom: {
		type: 'input'
	},
	related: {
		settings: EditorNewPasswordSettings
	}
};

export { EditorNewPassword };
